module.exports = __webpack_public_path__ + "coins.mp3";